import './notify_error_data_maybe_lost.less';

import isNil from 'lodash/isNil';
import React, { Fragment } from 'react';
import STATUS_CODES from 'builtin-status-codes';

import ConfirmSimpleModal from 'zoomforth_component_lib/confirm_simple_modal.jsx';



const ContactInfo = ({ canShowIntercom, onIntercomShow })=>
  <Fragment>
    Email <a href="mailto:support@zoomforth.com">
      support@zoomforth.com
    </a> 
    { canShowIntercom ? 
        <Fragment> or <a onClick={onIntercomShow}>chat with support</a></Fragment>
      :
        ''
    }
  </Fragment>;


export default ({ canShowIntercom, httpStatusCode, clientErrorDescription, serverMessage, onShowIntercom, ...props })=> {

  const hasStatusCode = !(isNil(httpStatusCode) || httpStatusCode === 0);
  
  var errorInfo = 'No message provided.';
  
  if (httpStatusCode === 400) {
    try{
      errorInfo = JSON.parse(serverMessage).error.message;
    } catch (e){ /* noop */ }
  }
  
  return (
    <ConfirmSimpleModal 
      className="notify-error-data-maybe-lost"
      closeOnOuterClick={false}
      hideCloseIcon={true}
      title="Error saving your last edit"
      body={ 
        <Fragment>
          <h3>
            {
              hasStatusCode ?
                `${httpStatusCode} ${STATUS_CODES[httpStatusCode]}`
              :
                'Unknown Request Error'
            }
          </h3>
          <h4>There was an error saving your last edit{ clientErrorDescription ? `: "${clientErrorDescription}"` : '.' }</h4>
          <div className="explain-error">
          {

             !hasStatusCode ?

              <Fragment>
                <p>
                  Unable to connect to Zoomforth servers. You might be disconnected
                  from the Internet.
                </p>
                <p>
                  If you think this is a problem with Zoomforth, then 
                  please <ContactInfo {...{canShowIntercom, onShowIntercom}} />.
                </p>
              </Fragment>
            
            : httpStatusCode === 400 ?
              
              
              <Fragment>
                <p>
                  Something about the most recent request was rejected by the server, with the message:
                </p>  
                <p className="explain-400">
                  {errorInfo}
                </p>
                <p>
                  If you think this is a problem with Zoomforth, then 
                  please <ContactInfo {...{canShowIntercom, onShowIntercom}} />.
                </p>
              </Fragment>
            

            
            : httpStatusCode === 401 ?
            
              <p> Something failed because of bad authorization. Please contact us if this problem persists. </p>

            : httpStatusCode === 403 ?

              <Fragment>
                <p>
                  It looks like you've been logged out.
                </p>
                <p>
                  You should <a href="/login">login to Zoomforth</a> again.
                </p>
                <p className="extra">
                  This might occur because you logged out in another tab or your session expired.
                </p>
              </Fragment>

            : httpStatusCode === 500 ?

              <Fragment>
                <p>
                  This is a problem on our end.
                </p>
                <p>
                  Our engineering team automatically receives a notification when this error
                  occurs. However, if you contact support and explain what you were doing when this error
                  occurred, it will speed up finding a fix. <ContactInfo {...{canShowIntercom, onShowIntercom}} />.
                </p>
              </Fragment>  

            : // Remember, this covers 404 Not Founds; Gateway Errors like (502, 503)

              <Fragment>
                <p>
                  This was an unexpected error. 
                </p>  
                <p>
                  Please report it to the Zoomforth Support Team.
                  <ContactInfo {...{canShowIntercom, onShowIntercom}} />.
                </p>
              </Fragment> 
          }
          </div>
          <div className="copy-your-work">
            <p>
              You need to refresh this site to get things working again—sorry about that.
            </p>
            <p>Some of what you were just editing may not have saved. But Zoomforth saves every 
              few seconds so you likely didn't lose much progress. To be safe, you can close 
              this window and copy what you were just working on.
            </p>
          </div>
        </Fragment>
      }
      cancelText="Close"
      confirmText="Refresh"
      {...props}
    />
  );
}
